import React from "react";
import AppBar2 from "../../appbar/AppBar2";

const AnonymousLayout = ({ children, hideLogoHeader }) => {
  return (
    <div>
      {
        !hideLogoHeader && <AppBar2 hideNotification />
      }
      
      <div className={!hideLogoHeader && "mt-[60px]"}>
        {children}
      </div>
    </div>
  );
};

export default AnonymousLayout;
